<template>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">RunSimlation</h4>
    </div>
    <div class="card-body">
      <div class="form-row form-group form-inline">
        <input type="text" class="form-control col-md-2" :value="GameRange" 
          @change="updateRange($event.target.value, 'GameRange');" />
        <label>試合×</label>
        <input type="text" class="form-control col-md-2" :value="YearRange" 
          @change="updateRange($event.target.value, 'YearRange');" />
        <label>年&nbsp;</label>
        <button type="button" class="btn btn-info btn-lg" style="width:120px"
        :disabled="LockEnter || SimuRangeCheck()[1] == 2"
        @click="GameEnter();">実行</button>
      </div>
      <div v-if="SimuRangeCheck()[0].length !== 0"
      class="alert alert-primary" role="alert"
      v-bind:class="{
        'alert-danger': SimuRangeCheck()[1] === 2,
        'alert-warning': SimuRangeCheck()[1] === 1}">
        {{SimuRangeCheck()[0]}}
      </div>
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" id="customControlRE" required
        :checked="UseRE" @change="updateValue(Boolean(!UseRE), 'UseRE')">
        <label class="custom-control-label" for="customControlRE">RE24系の計算</label>
      </div>
      
    </div>
  </div>
</template>

<script>
const SSta = require('simple-statistics');
import Mixin from '../mixins/utility'
import simmain from './gamescript/simmain.js'
import rrchange from '../assets/RerunChange.json'
import { mapState } from 'vuex'

import histgram from './histgram.vue'
let runcount = [0,0]
export default {
  
  name: 'index',
  components: {
      simmain, histgram
  },
  data() {
    return {
      DetailRecord: false,
      errorMsg: '',
    }
  },
  mixins: [Mixin],
  computed: {
    ...mapState([
      'UseRE', 'LockEnter',
    ]),
    SRList () {
      return function(mode) {
        let rlist = {
          0: ['name', 'AVG', 'HR', 'RBI', 'OBP', 'SLG', 'OPS'],
          1: this.FilterRecordList
        }
        return rlist[Number(mode)]
      }
    },
  },
  methods: {
    updateRange (vals , keyname) {
      this.$store.commit('updateValue', {vals: Number(this.hankaku2Zenkaku(vals)), keyname: keyname})
    },
    updateValue(vals, keyname) {
      this.$store.commit('updateValue', {vals: vals, keyname: keyname})
    },
    SimuRangeCheck () {
      let alert = ['', 0]
      if(isFinite(this.GameRange) == false
      || isFinite(this.YearRange) == false
      || this.GameRange < 1 || this.YearRange < 1) {
        alert[0] = '1以上の数字を入力してください'
        alert[1] = 2
      }else if(this.GameRange * this.YearRange >= 30000){
        alert[0] = '試行数が多いです。処理時間が長くなります'
        alert[1] = 1
      }
      return alert
    },
    GameEnter () {
      if(this.LockEnter == false){
        this.updateValue(true, 'LockEnter')
        this.SimlationGame()
        console.log(this.LockEnter)
        const uv = this.updateValue
        setTimeout( function() {
          // ロック画面の削除
          uv(false, 'LockEnter')
          console.log('aaaaaa')
        }, 1000 );
      }
    },
    SetSimdat (lu) {
      let Nine = []
      for(let index=0;index<9;index++) {
        const p = lu[index]
        let batting = {}

        this.InputRecordList.some(r =>{
          batting[r] = Math.max(0, Number(p[r]))
        })
        batting['jun'] = index
        batting['name'] = p.name
        batting['OUT'] = Math.max(0, batting['AB'] - batting['H'] - batting['SO'])
        batting['SING'] = Math.max(0, batting['H'] - batting['SEC'] - batting['THI'] - batting['HR'])

        batting['SH_rate'] = Number(p['SH_rate'])
        batting['SH_out'] = {}
        Object.keys(p['SH_out']).some(re =>{
          batting['SH_out'][re] = Boolean(p['SH_out'][re])
        })
        batting['SH_play'] = Boolean(p['SH_play']) * this.SH_flag
        batting['SH_plan'] = Number(p['SH_plan'])
        
        Nine.push(batting)
      }
      return Nine
    },
    SimlationGame () {
      const RE_flag = this.UseRE
      const JunS = ['ALL'].concat(Array.from(Array(9).keys()))
      function Totalization(nowdt, events, subseed) {
        //{Expected: {}, Probability: {}
        let RE_counter = {}
        let gamescore = 0
        let lasttotal = 0, lastout = 0

        events.some((ev, index) => {
          function AllNowArray() {
            return ['ALL', ev.jun]
          }
        //console.log(ev)
        {
        /*const run = ((index == 0 || index != 0 && events[index - 1].runner == '3 000') ? '0 000' : events[index - 1].runner)
        const r = run.split(" ")
        runcount[0]++;
        runcount[1]+=( r[1].match( new RegExp( '1', "g" ) ) || [] ).length;*/
        }
        if(RE_flag){
          const r = ((index == 0 || index != 0 && events[index - 1].runner == '3 000') ? '0 000' : events[index - 1].runner)
          AllNowArray().some(jun =>{
          if(nowdt.EvIncidence[jun] == undefined)nowdt.EvIncidence[jun] = {}
          if(nowdt.EvIncidence[jun][r] == undefined)nowdt.EvIncidence[jun][r] = 0
          nowdt.EvIncidence[jun][r] = nowdt.EvIncidence[jun][r]+1;

          if(RE_counter[jun] == undefined)RE_counter[jun] = {}
          if(RE_counter[jun][r] == undefined){ 
          RE_counter[jun][r] = {oppo: 0, runs: 0};
          }
          RE_counter[jun][r].oppo = RE_counter[jun][r].oppo+1;
          })
        }

        const r = ev.runner.split(" ");
        const OutCount = Number(r[0])
        const nowtotal = (OutCount == 3 ? 0 : (OutCount + ( r[1].match( new RegExp( '1', "g" ) ) || [] ).length));
        const totalsa = lasttotal - nowtotal + 1

        if(totalsa > 0 && OutCount != 3) {
          gamescore += totalsa
          
          if(ev.result != 'SO' && (ev.result != 'OUT' ||
          (lastout + 2 > OutCount) && (index + subseed) % 4 != 1)) {
              nowdt.player_total[ev.jun]['RBI'] += totalsa
          }//ここ減らす？
          Object.keys(RE_counter).some(jun =>{
            Object.keys(RE_counter[jun]).some(re => {
            RE_counter[jun][re].runs += totalsa * RE_counter[jun][re].oppo
            })
          })
        }
        ev.score = gamescore
        lastout = OutCount % 3
        lasttotal = nowtotal
        if(nowdt.player_total[ev.jun][ev.result] == undefined)nowdt.player_total[ev.jun][ev.result] = 0
        nowdt.player_total[ev.jun][ev.result] = nowdt.player_total[ev.jun][ev.result] + 1;
        nowdt.player_total[ev.jun]['PA'] = nowdt.player_total[ev.jun]['PA'] + 1
        if(OutCount >= 3){
          if(RE_flag) {
            Object.keys(RE_counter).some(jun =>{
              Object.keys(RE_counter[jun]).some(re => {
                if(nowdt.re_count['Expected'][jun] == undefined){
                nowdt.re_count['Expected'][jun] = {};
                nowdt.re_count['Probability'][jun] = {};
                }
                if(nowdt.re_count['Expected'][jun][re] == undefined) {
                nowdt.re_count['Expected'][jun][re] = {oppo: 0, runs: 0};
                nowdt.re_count['Probability'][jun][re] = {oppo: 0, runs: 0};
                }
                nowdt.re_count['Expected'][jun][re].oppo += RE_counter[jun][re].oppo
                nowdt.re_count['Expected'][jun][re].runs += RE_counter[jun][re].runs

                nowdt.re_count['Probability'][jun][re].oppo += Number(RE_counter[jun][re].oppo > 0)
                nowdt.re_count['Probability'][jun][re].runs += Number(RE_counter[jun][re].runs > 0)
              })
              RE_counter[jun] = {}
            })
          }
          if(index == events.length - 1 || events[index + 1].ining == 1 && events[index].ining >= 2) {
          nowdt.scores[nowdt.scores.length-1].push(gamescore)
          gamescore = 0
          }
        }
        })
        return nowdt//{ re_counter: nowdt.re_result}
      }
      console.time("loop time");
      console.log(rrchange)
      let newdata = {
        yearlen: this.YearRange,
        gamelen: this.GameRange,
        scores: [],
        player_total: {},
        re_count: {Expected: {}, Probability: {}, Occurrence: {} },
        event_exp: {}, 
        event_pro: {}, 
        EvIncidence: {},
        re_flag: true,
        gamelogs: [],
        chart_data: {}
      }
      const seed = 1 + parseInt(Math.random() * 1000)
      let dasen = this.SetSimdat(this.LineUp)
      let last_events
      dasen.some((player, j) => {
        newdata.player_total[j] = {}
        this.InputRecordList.some(r => {
          newdata.player_total[j][r] = 0;
        })
        newdata.player_total[j]['RBI'] = 0;
        newdata.player_total[j]['SING'] = 0;
        newdata.player_total[j]['OUT'] = 0;
        newdata.player_total[j]['PA'] = 0;
        newdata.player_total[j]['SH'] = 0;
        delete newdata.player_total[j]['H'];
        delete newdata.player_total[j]['AB'];
        newdata.player_total[j].name = player.name
      })
      
      for(let y = 0;y < this.YearRange; y=(y+1)|0) {
        newdata.scores[y] = []
        let events = new Array ()
        for(let g = 0;g < this.GameRange; g=(g+1)|0) {
          events = events.concat(simmain.GameMain(dasen, rrchange, this.SH_flag, null, null))//
        }
        newdata.gamelogs = events.slice()
        Totalization(newdata, events, y)
      }
      console.log(runcount)
      let re_result = {}
      Object.keys(newdata.re_count).some(type => {
          re_result[type] = {}
          Object.keys(newdata.re_count[type]).some(jun =>{
            re_result[type][jun] = {}
            Object.keys(newdata.re_count[type][jun]).some(re => {
              re_result[type][jun][re] = newdata.re_count[type][jun][re].runs / newdata.re_count[type][jun][re].oppo
            })
          })

      })
      let prec = {}, pt = newdata.player_total
      Object.keys(pt).some(j => {
        Object.keys(pt[j]).some(r => {
          if(prec[r] == undefined)prec[r] = 0
          prec[r] += pt[j][r]
        })
      });
      prec.name = 'ALL'
      pt[prec.name] = prec
      newdata.re_result = re_result
      
      const shout = this.SH_OutList

      if(RE_flag)for(let exnum = 0; exnum<2;exnum++)
      JunS.some(jun =>{
        const EventEx = GetEventExp(exnum?'Expected' : 'Probability', jun),
        evex_key = (exnum?'event_exp':'event_pro')
        Object.keys(EventEx).some(ev => {
          if(newdata[evex_key] == undefined)newdata[evex_key] = {}
          if(newdata[evex_key][jun] == undefined)newdata[evex_key][jun] = {}
          const ei_keys = Object.keys(newdata.EvIncidence[jun])
          
          
          let all_ex = 0
          ei_keys.some(re => {
            if(newdata.re_result['Occurrence'][jun] == undefined)
              newdata.re_result['Occurrence'][jun] = {}
            if(newdata.re_result['Occurrence'][jun][re] == undefined) {
              let total_re = 0
              for(let i = 0;i < ei_keys.length;i=(i+1)|0) total_re = newdata.EvIncidence[jun][ei_keys[i]] + total_re
              newdata.re_result['Occurrence'][jun][re] = newdata.EvIncidence[jun][re] / total_re
            }
            const r = EventEx[ev][re] * newdata.re_result['Occurrence'][jun][re]
            if(isNaN(r) == false)all_ex = r + all_ex
          })
          newdata[evex_key][jun][ev] = all_ex
        })
      })
      delete newdata.re_count

      function GetEventExp (expkey, jun) {
        let EventEx = {}
        function runnerCounter (runner) {
          const r = runner.split(' ');
          const OutCount = Number(r[0])
          return (OutCount == 3 ? 0 : (OutCount + ( r[1].match( new RegExp( '1', "g" ) ) || [] ).length));
        }
        function RunningCheck (mae, ato) {
          if (ato[0] === '3')return 0
          const totalsa = runnerCounter(mae) - runnerCounter(ato) + 1
          if(totalsa > 0) {
            return totalsa
          }
          return 0
        }
        re_result[expkey][jun]['3 000'] = 0

        Object.keys(rrchange).some(ev => {
          EventEx[ev] = {}
          const relist = (ev == 'SH' ? shout : Object.keys(rrchange[ev]))
          relist.some(re => {
            if(re !== '0'){
              let ex = 0
              Object.keys(rrchange[ev][re]).some(to => {
                if(to !== '0'){ 
                  let runs = (RunningCheck(re, to) + re_result[expkey][jun][to] - re_result[expkey][jun][re])
                  if(runs) {
                    if(expkey == 'Probability')runs = Math.max(Math.min(runs, 1.00), 0)
                    ex += runs * rrchange[ev][re][to]
                  }
                }
              })
              EventEx[ev][re] = ex
            }
          })
        })
        return EventEx
      }
      newdata.calc_flag = this.UseRE
      newdata.scores_data = this.PrintScore(newdata.scores);

      (['nen', 'all']).some(type => {
        newdata.chart_data[type] = this.ChartDataset(newdata.scores, type)
      })
      console.log(newdata)

      this.updateValue(newdata, 'result_sim')
      
      console.timeEnd("loop time");
      this.updateValue('res', 'TabActive')
    },
  },
}

</script>

<style scoped>
ul{
  margin: 0;
  padding: 0;
}
li{
  list-style: none;
}
li.active {
  fill: black;
}
svg {
  fill: currentColor;
}
.vue_radio input{
  display: none;
}
.inner{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/simenter.vue